import { action, observable, makeObservable } from 'mobx';
import {NodeData} from './node-data';
import {TreeNode} from './tree-node';
import {TreeUtils} from './tree-utils';

let U = TreeUtils;

function hasAnyNodeAtDepth2(root: TreeNode): boolean {
  return root.children.length > 0 &&
    root.children.find(child => child.children.length > 0) !== undefined;
}

export class TreeService {
  @observable.ref
  public root: TreeNode;

  private items: NodeData[];

  private nodesByRoute: { [index: string]: TreeNode };

  private selectedNode: TreeNode | null;

  private currentRoute: string;

  private savedExpandedNodeRoutes: string[];

  constructor() {
    makeObservable(this);
    this.items = [];
    this.root = U.makeRoot([]);
    this.nodesByRoute = {};
    this.selectedNode = null;
    this.currentRoute = '';
    this.savedExpandedNodeRoutes = [];
  }

  @action
  public setItems(items: NodeData[]) {
    if (items === this.items)
      return;
    this.items = items;
    if (hasAnyNodeAtDepth2(this.root))
      this.savedExpandedNodeRoutes = U.findExpandedNodes(this.root.children);

    this.root = U.makeRoot(items);
    this.nodesByRoute = U.makeNodeByRoute(this.root.children);
    this.selectedNode = null;

    if (hasAnyNodeAtDepth2(this.root)) {
      this.expandNodes(this.savedExpandedNodeRoutes);
      this.savedExpandedNodeRoutes = [];
      if (this.currentRoute !== null)
        this.setCurrentRoute(this.currentRoute);
    }
  }

  @action
  expandAllNodes() {
    U.expandAll(this.root.children);
  }

  @action
  private expandNodes(routes: string[]) {
    const nodesByRoute = this.nodesByRoute;
    for (let route of routes) {
      const node = nodesByRoute[route];
      if (node !== undefined)
        node.expand();
    }
  }

  @action
  private _clearSelection() {
    if (this.selectedNode !== null)
      this.selectedNode.selected = false;
    this.selectedNode = null;
  }

  @action
  public setCurrentRoute(route: string) {
    this._clearSelection();
    this.currentRoute = route;

    const node = this.nodesByRoute[route];
    if (node !== undefined) {
      this.selectedNode = node;
      node.selected = true;
      U.expandAllUp(node.parent!);
    }
  }
}
